import React from "react";
import themePropTypes from "../theme-prop-types";

const Tooltip = ({ children, message, position = "top" }) => (
  <div className='tooltip-wrapper-web-sdk'>
    <div className='tooltip-presenter-web-sdk'>{children}</div>
    <div className={`tooltip-message-web-sdk tooltip-${position}-web-sdk`}>
      {message}
    </div>
  </div>
);

Tooltip.propTypes = themePropTypes.tooltip;

export default Tooltip;
